export const CURRENT_STEP = "currentStep";
export const CURRENT_SECTION = "currentSection";
export const USER_DATA = "userData";
export const KEY = "key";
export const EXPIRES = "expires";
export const PATH = "path";
export const MAX_AGE = "Max-Age";
export const AUTHENTICATION_TOKEN = "authToken";
export const BEARER = "Bearer";
export const SECTION = "section";
export const STEP = "step";

export const BROWSER_HEADERS = Object.freeze({
  XAuthJwt: "x-authentication-jwt",
});
